
<div class="header-app-banner {{project}}">
  <div class="header-app-banner-wrapper">
    <p *ngFor="let i of itemCounter" [innerHTML]="text"></p>
  </div>
</div>
